import React from 'react';
import HomeHeader from '@/src/shared/components/HomeHeader';
import SeoConfig from '@/src/core/components/SeoConfig';
import config from '@/config';

import styles from '@/src/containers/AboutUs/AboutUs.module.scss';
import HeroSection from '@/src/containers/AboutUs/components/HeroSection';
import OurMission from '@/src/containers/AboutUs/components/OurMission';
import FromRoomvuToVusocial from '@/src/containers/AboutUs/components/FromRoomvuToVusocial';
import Press from '@/src/containers/AboutUs/components/Press';
import Testimonial from '@/src/containers/Landings/Testimonial';
import LandingStats from '@/src/containers/Landings/LandingStats';
import Reviews from '@/src/containers/Landings/Reviews';
import Footer from '@/src/containers/Landings/Footer';
import OurPresence from '@/src/containers/AboutUs/components/OurPresence';
import AsSeenSection from '@/src/containers/Landings/AsSeenSection';

function AboutUsPage() {
  return (
    <>
      <SeoConfig
        title="About VuSocial — AI Video Content with Your Voice & Brand"
        description="VuSocial helps advisors grow with daily branded AI videos—your voice, your face, your brand."
        image="https://dofimomuk6s4.cloudfront.net/files/th-about-us.jpg"
        canonical={config.websiteBaseUrl + '/about'}
      />

      <HomeHeader
        bgColor="transparent"
        classes={{
          root: styles.header,
        }}
      />

      <div className={styles.container}>
        <HeroSection />
        <OurMission />
        <FromRoomvuToVusocial />
        <Press />
        <OurPresence />
        <LandingStats />
        <Testimonial />
        <Reviews />
        <AsSeenSection />
      </div>

      <Footer hasScrollToTop />
    </>
  );
}

AboutUsPage.pageName = 'about-us';
AboutUsPage.withIntercomChatBot = true;
export default AboutUsPage;
